import React from "react";
import { Box, Typography } from "@mui/material";
import AppPagination from "./AppPagination";

const AppPaginationBar = ({
  pagination,
  pageSize,
  onPageChange,
  itemLabel = "items",
  hidePagination = false
}) => {
  if (!pagination) return null;

  const { current_page, page_size, total_items, total_pages } = pagination;
  const effectivePageSize = pageSize ?? page_size ?? 10;
  const hasTotal =
    typeof total_items === "number" && !Number.isNaN(total_items);

  let showingText;

  if (hasTotal && total_items > 0) {
    const start = (current_page - 1) * effectivePageSize + 1;
    const end = Math.min(current_page * effectivePageSize, total_items);
    showingText = `Showing ${start} - ${end} of ${total_items} ${itemLabel}`;
  } else if (hasTotal) {
    showingText = `Showing 0 of 0 ${itemLabel}`;
  } else {
    showingText = `No ${itemLabel}`;
  }

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        alignItems: "center",
        // justifyContent: "space-between",
        flexWrap: "wrap",
        rowGap: 1,
        flexDirection: "column",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {showingText}
      </Typography>

      {onPageChange && total_pages > 1 && !hidePagination && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <AppPagination
            count={total_pages}
            page={current_page}
            onChange={onPageChange}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default AppPaginationBar;

